/**
 * 全局配置文件
 */
export default {
  appId: 'wx9eeb73e006799e6e',
  backUrl: 'http://mp.sansint.com/'
}
